/**
 * What the Employees page's invite and reset confirmations say and offer.
 *
 * Sign-in is by email only (ADR-0017): an employee with no email on file
 * cannot be invited or reset — the API refuses — so the dialog explains why
 * and its action opens the edit form to add one instead of calling the API.
 */
export interface MobileAccessPrompt {
  description: string;
  /** False when the employee has no email; the action then opens the edit form. */
  canProceed: boolean;
  actionLabel: string;
}

type Person = { name: string; email: string | null };

export function invitePrompt(e: Person): MobileAccessPrompt {
  if (!e.email) return noEmailPrompt(e.name);
  return {
    description: `An invitation email will be sent to ${e.email}. They'll set their own password and sign in with that email address.`,
    canProceed: true,
    actionLabel: "Send invitation",
  };
}

export function resetPrompt(e: Person): MobileAccessPrompt {
  if (!e.email) return noEmailPrompt(e.name);
  return {
    description: `Existing mobile sessions for ${e.name} will be revoked. They'll use 'Forgot password' on the sign-in screen to set a new one (Clerk emails the reset link from there).`,
    canProceed: true,
    actionLabel: "Revoke sessions & scramble password",
  };
}

function noEmailPrompt(name: string): MobileAccessPrompt {
  return {
    description: `${name} has no email address on file. Sign-in is by email, so add one to their record first.`,
    canProceed: false,
    actionLabel: "Add email",
  };
}
